<template>
  <v-chip
    :small="!large"
    v-bind="$attrs"
    v-on="$listeners"
    :color="active ? 'primary' : null"
    :text-color="active ? 'white' : null"
  >
    <span v-if="icon">{{ icon }}&nbsp;</span>{{ value }}
  </v-chip>
</template>

<script>
import { tagIcon } from "@/utils/TagUtils";

export default {
  name: "RecipeTag",
  props: {
    active: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      required: true
    }
  },
  computed: {
    icon() {
      return tagIcon(this.value);
    }
  }
};
</script>
